import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { Controller } from '@grnhse/seedling/lib/birch/components/forms/form';

type CheckboxFieldGroupProps = {
  name: string;
  options: { label: string; value: string }[];
};

function CheckboxFieldGroup({ name, options }: CheckboxFieldGroupProps) {
  return (
    <Controller
      name={name}
      render={({ field }) => {
        const { onChange, value } = field;
        return (
          <>
            {options.map((option, i) => (
              <Checkbox
                key={i}
                data-provides={`ai-feedback-${option.value}`}
                label={option.label}
                value={option.value}
                checked={value.includes(option.value)}
                onChange={(checked) => {
                  const newValue = checked
                    ? [...value, option.value]
                    : value.filter((val: string) => val !== option.value);
                  onChange(newValue);
                }}
              />
            ))}
          </>
        );
      }}
    />
  );
}

export default CheckboxFieldGroup;
